import { Component, computed, inject } from '@angular/core';
import { DashboardStatsCardComponent } from '../../../components/dashboard-stats-card/dashboard-stats-card.component';
import { PackageService } from '@lib/package/package.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { catchError, of } from 'rxjs';

@Component({
    selector: 'app-count-offered-packages',
    imports: [
        DashboardStatsCardComponent
    ],
    templateUrl: './count-offered-packages.component.html',
    standalone: true,
    styleUrl: './count-offered-packages.component.scss'
})
export class CountOfferedPackagesComponent {
    private readonly _packageService = inject(PackageService);
    protected readonly Number = Number;

    offeredPackagesCountResult = toSignal(
        this._packageService.countOfferedPackages().pipe(
            catchError(() => of(null))
        )
    );

    offeredPackages = computed(() => this.offeredPackagesCountResult()?.count);

    getPackageCount(): number {
        return this.offeredPackages() && Number(this.offeredPackages()) > 0 ? Number(this.offeredPackages()) : 0;
    }
}
